/**
 * Custom Product Builder — sticky buy bar.
 *
 * The builder is a React root we do not control, so the bar never renders its own
 * add-to-cart: it mirrors the builder's live price and forwards clicks to the real
 * button. Anything else would submit a cart the builder does not know about.
 *
 * Selectors are limited to CPB's stable `cpb-*` classes. The `sc-*` classes are
 * styled-components hashes that change on every CPB release.
 */
(function () {
  'use strict';

  var bar = document.getElementById('CpbStickyBar');
  var priceEl = document.getElementById('CpbStickyPrice');
  var progressEl = document.getElementById('CpbStickyProgress');
  var cta = document.getElementById('CpbStickyCta');
  var root = document.getElementById('product-builder');

  // The Custom Shop owns purchase inside its guided summary. When this legacy
  // bar is intentionally hidden, do not keep CPB-wide observers alive.
  if (!bar || !root || bar.hidden || window.getComputedStyle(bar).display === 'none') return;

  var BUILDER_TIMEOUT = 20000;

  function waitForBuilder(callback) {
    var found = root.querySelector('.cpb-add-to-cart-button');
    if (found) {
      callback(found);
      return;
    }

    var startedAt = Date.now();
    var observer = new MutationObserver(function () {
      var button = root.querySelector('.cpb-add-to-cart-button');
      if (button) {
        observer.disconnect();
        callback(button);
      } else if (Date.now() - startedAt > BUILDER_TIMEOUT) {
        observer.disconnect();
      }
    });

    observer.observe(root, { childList: true, subtree: true });
  }

  waitForBuilder(function (addToCart) {
    var priceSource = root.querySelector('.cpb-product-price');

    function syncPrice() {
      if (!priceSource || !priceEl) return;
      priceEl.textContent = priceSource.textContent.trim();
    }

    /**
     * CPB marks nothing as "selected" in the DOM, so progress is derived by
     * snapshotting each category's untouched text and comparing against it. That
     * survives translating the "Select..." placeholder, which a hardcoded string
     * would not. If a category ships with a preselected default it reads as
     * pending, so the count is hidden rather than shown wrong.
     */
    var categories = Array.from(root.querySelectorAll('.cpb-category'));
    var initialText = categories.map(function (category) {
      return category.textContent.trim();
    });
    var canTrackProgress = categories.length > 0;

    function syncProgress() {
      if (!progressEl || !canTrackProgress) return;

      var chosen = categories.filter(function (category, index) {
        return category.textContent.trim() !== initialText[index];
      }).length;

      progressEl.textContent = chosen + ' de ' + categories.length + ' elegidos';
    }

    var scheduled = false;
    function scheduleSync() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () {
        scheduled = false;
        syncPrice();
        syncProgress();
      });
    }

    new MutationObserver(scheduleSync).observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    syncPrice();
    syncProgress();

    cta.addEventListener('click', function () {
      addToCart.click();
    });

    // Show the bar only once the builder's own add-to-cart has scrolled away.
    bar.hidden = false;
    new IntersectionObserver(
      function (entries) {
        bar.classList.toggle('is-visible', !entries[0].isIntersecting);
      },
      { rootMargin: '0px 0px -80px 0px' }
    ).observe(addToCart);
  });
})();
